// Header.js
import React, { useRef, useState, useEffect } from "react";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MessageIcon from '@mui/icons-material/Message';
import { useNavigate } from 'react-router-dom';
import Api from "./Api";
import ISChangePassword from '../Pages/IS/changePassword'; 


function Header({ logo, handleLogout }) {

    const changePasswordRef = useRef();

    const navigate = useNavigate();

    const [showPopup, setShowPopup] = useState(false);
    const [showMessagesPopup, setShowMessagesPopup] = useState(false);
    const [time, setTime] = useState(new Date());
    const [userInfoOpen, setuserInfoopen] = useState(false);
    const dropdownRef = useRef(null);
    const [messages, setMessages] = useState([]);
    const [count, setCount] = useState(0);
    const [notiSubject, setNotiSubject] = useState("");
    const [notiMessage, setNotiMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [notiId, setNotiId] = useState(null);


    const [getuserTypes, setUserType] = useState(localStorage.getItem("usertype") || ''); // Get user type from localStorage or set default value

    const getuserType = localStorage.getItem("usertype");



    useEffect(() => {
        const fetchTime = async () => {
            try {
                const response = await fetch("https://ugpapi.mgu.ac.in/api/College/getServerTime");
                if (response.ok) {
                    const data = await response.json(); // Parse the API response as JSON
                    const utcDate = new Date(data.server_time); // Convert the UTC time string to a Date object

                    // Convert UTC to IST
                    // const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC + 5:30
                    // const istDate = new Date(utcDate.getTime() + istOffset);
                    setTime(utcDate); // Set the initial IST time
                } else {
                    console.error("Error fetching server time:", response.status);
                }
            } catch (error) {
                console.error("Error fetching server time:", error);
            }
        };

        fetchTime(); // Fetch the initial time from the API
        // Increment time locally every second
        const localInterval = setInterval(() => {
            setTime((prevTime) => {
                if (!prevTime) return null; // Ensure time is available before incrementing
                return new Date(prevTime.getTime() + 1000); // Increment the time by 1 second
            });
        }, 1000);

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                // Fetch time again when the tab becomes active
                fetchTime();
            }
        };

        // Attach visibility change event listener
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            clearInterval(localInterval); // Cleanup interval on component unmount
            document.removeEventListener("visibilitychange", handleVisibilityChange); // Cleanup event listener
        };
    }, []);

    useEffect(() => {
        const reload = async () => {
            try {
                const { http } = Api();
                const response1 = await http.get(`/Admin/getNotificationsAndMessages`);

                if (response1.data.status_code !== "ERR5") {
                    const msgList = response1.data.filter((o) => o.msg_type === "message");

                    const unreadCount = msgList.filter((o) => o.status === "sent").length;

                    setMessages(msgList);
                    setCount(unreadCount);
                } else {
                    setMessages([]);
                    setCount(0);
                }
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
        };

        reload();
    }, []);
    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleViewModalOpen = (msgId, subject, message, status) => {
        setNotiSubject(subject);
        setNotiMessage(message);
        console.log("skhakjf", message)
        setShowModal(true);

        const markAsRead = async () => {
            try {
                const { http } = Api();
                await http.post(`/Admin/markAsRead`, { id: msgId });
                setNotiId(msgId);

                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === msgId ? { ...msg, status: "read" } : msg
                    )
                );

                setCount(prevCount => prevCount - 1);

                console.log("Message marked as read");
            } catch (error) {
                console.error("Error in marking as read", error);
            }
        };

        if (status === "sent") {
            markAsRead();
        }
    };



    const handleChangePassword = () => {

        const userType = localStorage.getItem("usertype");



        if (userType == 1) {
            navigate("/admin/adminChangePassword");
        }

        else if (userType == 2) {
            navigate("/college/changepassword");
        }
        else if (userType == 15) {
            navigate("/bos/BOSChangePassword");
        }
        else if (userType == 22) {
            navigate("/sfa/sfachangepassword");
        } else if (userType == 27) {
            changePasswordRef.current?.open();
        }
        else {
            alert("Invalid user type. Cannot navigate to change password page.");
        }


    };

    const toggleUserinfo = () => {
        setShowPopup(!showPopup);
        //setuserInfoopen((prev) => !prev);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                //setuserInfoopen(false);
                setShowPopup(false);
            }
        };

        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);

    return (
        <div className="top-bar bg-light shadow py-2 position-relative" style={{ height: "65px" }}>
            <div className="container-fluid position-relative">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img src={logo} alt="Logo" style={{ width: '100%', maxWidth: '180px' }} />
                    </div>
                    <div className="col-md-6 text-end justify-content-end align-items-center cd-lbl-sh-hd">
                        <div className="text-dark text-decoration-none position-relative "
                            ref={dropdownRef} >
                            <AccountCircleIcon className="username-icn clg-icn-clr1" style={{ cursor: 'pointer', marginTop: '11px' }}
                                onClick={toggleUserinfo}
                            />
                            <div className="pdg9 clg-mgs-wt"> {localStorage.getItem('username')}
                                <br /><div className="text-white badge bg-primary text-wrap " style={{ fontSize: '13px;' }}>{time ? (
                                    <>
                                        {time.toLocaleDateString("en-IN", {
                                            day: "numeric",
                                            month: "long",
                                            year: "numeric",
                                        })}
                                        &nbsp;
                                        {time.toLocaleTimeString("en-IN", {
                                            hour: "numeric",
                                            minute: "numeric",
                                            second: "numeric",
                                            hour12: true,
                                        })}
                                    </>
                                ) : (
                                    <>Loading...</>
                                )}</div>
                            </div>

                            {showPopup && (
                                <div className="popup-box popup-box-li top-100 end-0"

                                >
                                    {getuserType !== "22" && (
                                        <div
                                            className="dropdown-item dropdown-item-li d-flex align-items-center"
                                            onClick={handleChangePassword}
                                            style={{ cursor: 'pointer', padding: '10px 0px' }}
                                        >
                                            <i className="fas fa-key fa-sm fa-fw me-2"></i>
                                            Change Password
                                        </div>
                                    )}

                                    <div
                                        className="dropdown-item dropdown-item-li d-flex align-items-center"
                                        onClick={handleLogout}
                                        style={{ cursor: 'pointer', padding: '10px 0px' }}
                                    >
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw me-2"></i>
                                        Logout
                                    </div>
                                </div>
                            )}

                        </div>
                        <div
                            className="text-dark text-decoration-none position-relative me-4"
                            onMouseEnter={() => setShowMessagesPopup(true)}
                            onMouseLeave={() => setShowMessagesPopup(false)}
                        >
                            <MessageIcon
                                className="username-icn icn-fn-sz clg-icn-clr2"
                                aria-hidden="true"
                            />

                            {count > 0 && (
                                <span className="message-count" style={{ top: "0px", right: "0px" }}>
                                    {count}
                                </span>
                            )}

                            {showMessagesPopup && (
                                <div
                                    className="messages-popup mr-10 pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht2 scrollable-bar-wt"
                                    style={{ top: "100%", right: "0px", width: "334px" }}
                                    >                                    <div className="title-message1">Messages</div>

                                    <ul style={{ padding: "15px" }}>
                                        {Array.isArray(messages) && messages.length > 0 ? (
                                            messages.map((item) => (
                                                <li key={item.id} className="b-l-primary border-4 newstyle">
                                                    <p
                                                        role="button"
                                                        style={{ cursor: "pointer", textAlign: "left" }}
                                                        onClick={() => {
                                                            setShowMessagesPopup(false);
                                                            handleViewModalOpen(item.id, item.subject, item.message, item.status)
                                                        }}
                                                    >
                                                        {item.subject?.length > 20
                                                            ? item.subject.substring(0, 30) + "..."
                                                            : item.subject}

                                                        {item.status === "sent" && (
                                                            <span className="badge badge-light-secondary ml-2">New</span>
                                                        )}
                                                    </p>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="b-l-primary border-4 newstyle">
                                                <p>You currently have no messages.</p>
                                            </li>
                                        )}

                                    </ul>

                                    <div
                                        className="card-footer text-center"
                                        style={{ borderRadius: "5px" }}
                                    >
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal moved here - outside the nested divs */}
            {showModal && (
                <div
                    style={{ backgroundColor: "#7a787878" }}
                    className="modal fade bd-example-modal-lg show d-block"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="myExtraLargeModal"
                >
                    <div className="modal-dialog modal-lg" style={{ textAlign: "-webkit-center" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title mobile1" id="myExtraLargeModal" style={{ color: '#000' }}>
                                    {notiSubject}
                                </h4>

                                <button
                                    className="btn-close py-0"
                                    type="button"
                                    aria-label="Close"
                                    onClick={handleModalClose}
                                />
                            </div>

                            <div className="modal-body dark-modal">
                                <div className="large-modal-header">
                                    <i data-feather="chevrons-right"></i>
                                </div>

                                <p className="modal-padding-space mb-0 mobilep" style={{ color: '#000' }}>
                                    {notiMessage}
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ISChangePassword ref={changePasswordRef} />
            
        </div>
    );
}

export default Header;